import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getGiftHistoryRequest,
  getGiftHistorySuccess,
  getGiftHistoryFailure,
  createGiftRequest,
  createGiftSuccess,
  createGiftFailure,
  generateGiftOtpRequest,
  generateGiftOtpSuccess,
  generateGiftOtpFailure,
  verifyGiftOtpRequest,
  verifyGiftOtpSuccess,
  verifyGiftOtpFailure
} from "./giftSlice";
import { toast } from "react-toastify";

function* fetchGiftHistory(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/gift/gift-orders`)
    );

    if (response.data.success) {
      yield put(getGiftHistorySuccess(response.data));
    } else {
      yield put(
        getGiftHistoryFailure(response.data.message || "Failed to fetch gift history")
      );
      toast.error(response.data.message || "Failed to fetch gift history");
    }
  } catch (error) {
    yield put(getGiftHistoryFailure(error.message));
    toast.error("Error fetching gift history");
  }
}

function* generateGiftOtp(action) {
  try {
    const { phoneNumber } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/otp-generator/generateotp`,
      { otpSrc: phoneNumber, otpType: "GIFT", otpFor: "Customer",jeweller : process.env.REACT_APP_JEWELLER_ID},
      {
        headers: {
          version: "1.1.1",
        },
      }
    );
    if (response.data.success) {
    yield put(generateGiftOtpSuccess(response.data));
    toast.success(response.data.data)
    }
    else {
        yield put(generateGiftOtpFailure(response.data.message || "Failed to generate OTP"));
        toast.error(response.data.message || "Failed to generate OTP");
    }
  } catch (error) {
    yield put(
      generateGiftOtpFailure(error.response?.data?.message || error.message)
    );
  }
}

function* verifyGiftOtp(action) {
  try {
    const { otp, phoneNumber, giftData } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/otp-generator/verifyOtp`,
      {otpSrc : phoneNumber, otp, otpType: "GIFT", otpFor: "Customer", jeweller : process.env.REACT_APP_JEWELLER_ID},
      {
        headers: {
          "Content-Type": "application/json",
          version: "1.1.1",
        },
      }
    );
    if (response.data.success) {
       yield put(verifyGiftOtpSuccess(response.data));
       toast.success(response.data.message || "OTP verified successfully");

       yield put(createGiftRequest(giftData));
    }
    else{
        yield put(verifyGiftOtpFailure(response.data.message || "Failed to verify OTP"));
        toast.error(response.data.message || "Failed to verify OTP");
    }
  } catch (error) {
    yield put(
      verifyGiftOtpFailure(error.response?.data?.message || error.message)
    );
  }
}

function* createGift(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/gift/createGiftOrder`,
      action.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.data.success) {
        yield put(createGiftSuccess(response.data));
        toast.success(response.data.message || "Gift created successfully");
    }
    else{
        yield put(createGiftFailure(response.data.message || "Failed to create gift"));
        toast.error(response.data.message || "Failed to create gift");
    }
  } catch (error) {
    yield put(
      createGiftFailure(error.response?.data?.message || error.message)
    );
  }
}



export function* giftSaga() {
  yield takeLatest(getGiftHistoryRequest.type, fetchGiftHistory);
  yield takeLatest(createGiftRequest.type, createGift);
  yield takeLatest(generateGiftOtpRequest.type, generateGiftOtp);
  yield takeLatest(verifyGiftOtpRequest.type, verifyGiftOtp);
}
